import React from 'react';
import T from 'prop-types';
import { Button, Typography } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import * as Sentry from '@sentry/browser';

import { Container } from './style';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      eventId: null,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  render() {
    const { hasError, eventId } = this.state;
    if (!hasError) {
      return this.props.children;
    }

    return (
      <Container description={null} image="/images/error.svg">
        <Typography.Paragraph strong>Something went wrong</Typography.Paragraph>
        <Typography.Paragraph>Our team has been notified about this error.</Typography.Paragraph>
        <Button href="/" icon={<HomeOutlined />} type="primary">
          Go Home
        </Button>
        <Button onClick={() => Sentry.showReportDialog({ eventId })}>Report feedback</Button>
      </Container>
    );
  }
}

ErrorBoundary.propTypes = {
  children: T.node.isRequired,
};

export default ErrorBoundary;
